@if (showAgileBoardSort) {
<div class="agile-sort-container">
  <p-select
    [options]="sortOptions"
    [(ngModel)]="selectedSortField"
    name="sortField"
    optionLabel="label"
    optionValue="value"
    (onChange)="onSortFieldChange($event.value)"
    placeholder="Sort by"
    [showClear]="false"
    class="sort-dropdown">
  </p-select>
  <button
    pButton
    pRipple
    type="button"
    [icon]="sortIcon"
    (click)="onSortDirectionToggle()"
    class="p-button-text p-button-plain p-button-lg tool-bar-pbutton sort-direction-btn"
    [pTooltip]="sortDirection === 'asc' ? 'Sort Ascending' : 'Sort Descending'"
    [tooltipStyleClass]="'agile-sort-tooltip'"
    [attr.aria-label]="sortDirection === 'asc' ? 'Sort Ascending' : 'Sort Descending'"></button>
</div>
}
